import React from "react";
import classNames from "classnames";

export function MobileTabs({children}) {
  return (
    <nav className="mobile-tabs">
      <ul className="tab-list">
        {children}
      </ul>
    </nav>
  );
}

export function MobileTab(props) {
  const className = classNames({
    tab: true,
    list: props.label === "List",
    map: props.label === "Map",
    "tab--active": props.active,
  });

  return (
    <li className={className} onClick={props.onClick}>{props.label}</li>
  );
}
